import Order from "../pages/order";

export default [{ path: "/orders", component: Order }];
